module.exports = __webpack_public_path__ + "static/media/image_1.469828bf.jpg";